<template>
  <section class="settings-card">
    <ActivityLogPanel />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ActivityLogPanel from '@/components/dashboard/ActivityLogPanel.vue'
export default defineComponent({ name: 'SystemTabAtividades', components: { ActivityLogPanel } })
</script>

<style scoped lang="scss">
.settings-card { border: 1px solid rgba(31,30,26,.1); border-radius: 14px; background: var(--card,#fff); padding: 22px 24px; }
</style>
